import type { ReactNode } from 'react';

export const symbol_keyboard_tab_rtl: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-240q-13 0-21.5-8.5T80-270v-420q0-13 8.5-21.5T110-720q13 0 21.5 8.5T140-690v420q0 13-8.5 21.5T110-240Zm244-210 147 147q9 9 9 21.5t-9 21.5q-9 9-21 9t-21-9L260-459q-5-5-7-10t-2-11q0-6 2-11t7-10l199-199q9-9 21-9t21 9q9 9 9 21t-9 21L354-510h496q13 0 21.5 8.5T880-480q0 13-8.5 21.5T850-450H354Z"
		/>
	</svg>
);
